
import Vue from 'vue'
import QuantificationTransformer from '@/transformers/purchase/quantification'
import errorHandler from '@/utils/errorHandler'

export default (affectedId, opts = {}) => {
  const { fetchPrices } = opts
  const url = `purchase/quantification${fetchPrices ? '_prices' : ''}/${affectedId}/`
  return errorHandler(Vue.$http.get(url), { separator: "\n"})
    .then(response => {
      const data = QuantificationTransformer.fetch(response.data)
      return data
    })
    .catch(error => {
    	const response = error.response
    	if (response && response.status !== 404) {
    		throw error
    	} 
    })
}



// WEBPACK FOOTER //
// ./src/services/purchase/fetchConceptsValidation.js